<template>
  <v-container fluid grid-list-lg>    
      <v-layout wrap >
        <v-flex xs12 sm10 lg8>
        <v-card>
          <v-toolbar color="indigo" dark>

            <v-toolbar-title>{{label}}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn :outlined="verActivos" small @click="toggleVerActivos">
              {{verActivos ? 'Ocultar dado de Baja' : 'Ver dado de Baja'}}
            </v-btn>
            <v-btn icon @click="addChild">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list>
            <v-list-item v-for="cuentaBanco in cbuMostrados" :key="cuentaBanco.orden">              
              <app-cuenta-banco-completo :value="cuentaBanco" ref="hijos" :cuentasExistentes="cuentasBanco"
                                        v-on:cancelar-ingreso="cancelarIngreso($event)"></app-cuenta-banco-completo>
            </v-list-item>
          </v-list>          
        </v-card>
      </v-flex>
    </v-layout>    
  </v-container>  
</template>

<script>

import Vue from 'vue'


export default {
   data: () => ({    
    loading: false,
    verActivos:false,
    cuentasBanco: [],    
  }),
  props: {
    value: {
      type: Object,
      required: false
    },
    propName:{
        type: String,
        required: false,
        default: 'cuentasBanco'
    },
    label: {
      type: String,
      default: 'Cuentas Bancarias'
    },
    iconName: {
      type: String,
      default: 'phone'
    }
  },
  watch:{
      'value.cuentasBanco': function(item){
        this.cuentasBanco = item;
        this.setCuentas()
        this.MotivoBaja()
      }
  },
   created () {    
    // cargo el modelo
    this.setCuentas()
  },
  computed:{
      cbuMostrados: function(){
        if(!this.cuentasBanco || this.cuentasBanco.activo == 0) return [];

        if(this.verActivos)
          return this.cuentasBanco;
        else
          return this.cuentasBanco.filter(cB => cB.activo)
        
      }
  },
  methods: {      
      setCuentas(){
        if(!this.value[this.propName]){ // Si las cuentas no están cargadas, creo la propiedad 
            this.cuentasBanco = []
            
            this.value[this.propName] = this.cuentasBanco
        }
        this.cuentasBanco = this.value[this.propName]
      },      
      async addChild(){

        const res = await this.$dialog.confirm({
          text: '¿Está seguro que quiere agregar una Cuenta Bancaria?',
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...
        })

        if (!res) {
          return;
        }
        
        var ultimoOrden = 0; // Busco el último orden que hay
        for (let index = 0; index < this.cuentasBanco.length; index++) {
          ultimoOrden = this.cuentasBanco[index].orden;
        }

        //todo: al agregar cuenta, traer datos predeterminados (por ejemplo el prefijo en base a la sucursal, etc)

        var nuevaCuenta = {
                esAlias: false,
                activo: true,
                cbu: '',
                cbuValidado: false,
                esDeOtroTitular: false,
                tipoCuentaId: 1,
                sucursalBanco: null,
                cuilTitular: null,
                nombreTitular: null,
                fechaAlta: this.$moment(new Date()).format('YYYY-MM-DD'),
                orden: ultimoOrden + 1                
        }

        this.cuentasBanco.push(nuevaCuenta);

        Vue.nextTick(() => { // esto es para esperar a que se renderice el componente nuevo
          this.$refs.hijos.find(ref=>ref.cuentaBanco.orden == nuevaCuenta.orden).editModeOn = true;
        }); 
      },
      async deleteChild(cuentasAEliminar){
        const res = await this.$dialog.prompt({
          text: 'Ingrese el Motivo de la Baja', 
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...   
        })

        if (res) {
          var indiceAEliminar = -1;
          for (let index = 0; index < this.cuentasBanco.length; index++) {
            if(this.cuentasBanco[index].orden == cuentasAEliminar.orden){
              indiceAEliminar = index;
              break;
            }
          }

          //Vue.$log.debug(indiceAEliminar);

          if(indiceAEliminar >=0){
            this.cuentasBanco.splice(indiceAEliminar,1);
          }
          
          this.value.motivoBajaCuentaBanco = res
        }
      },
      cancelarIngreso(ordenAEliminar)
      {
        Vue.$log.debug(ordenAEliminar);
        var indiceAEliminar = -1;

        for (let index = 0; index < this.cuentasBanco.length; index++) {
            if(this.cuentasBanco[index].orden == ordenAEliminar){
              indiceAEliminar = index;
              break;
            }
        }
        if(indiceAEliminar >=0){
            this.cuentasBanco.splice(indiceAEliminar,1);
        }
      },
      toggleVerActivos(){
        this.verActivos = !this.verActivos;
      }
  }
}
</script>

<style>

</style>
